<div class="pb-6">
  <h2 class="fw-bolder d-flex text-dark">
    {{ "WIZARD.ACCOUNT_TYPE" | translate }}
  </h2>
<!--  <div class="text-gray-400 fw-bold fs-6">-->
<!--    {{ "WIZARD.ACCOUNT_TYPE_HELP" | translate }}-->
<!--    <a href="#" class="link-primary fw-bolder"> {{ "WIZARD.ACCOUNT_TYPE_HELP_PAGE" | translate }} </a>-->
<!--  </div>-->
</div>
<form
  noValidate
  id="kt_create_account_form"
  [formGroup]="form">
  <div class="tiles-row">
    <div class="row">
      <div
        *ngIf="!whiteLabelService.isWhiteLabel"
        class="col-lg-6"
      >
        <input
          formControlName="accountType"
          name="accountType"
          type="radio"
          class="btn-check"
          id="kt_create_account_form_account_type_personal"
          value="shop"
        />
        <label
          class="
          btn btn-outline btn-outline-dashed btn-outline-default
          p-7
          d-flex
          align-items-center
          mb-6 mb-lg-0
        "
          for="kt_create_account_form_account_type_personal"
        >
        <span
          [inlineSVG]="'./assets/media/icons/duotune/communication/com005.svg'"
          class="svg-icon svg-icon-3x me-5"
        ></span>
          <span class="d-block fw-bold text-start">
          <span class="text-dark fw-bolder d-block fs-4 mb-2"
          >{{ "WIZARD.ACCOUNT_TYPE_SHOP" | translate }}</span
          >
          <span class="text-gray-400 fw-bold fs-6">
            {{ "WIZARD.ACCOUNT_TYPE_SHOP_DESC" | translate }}
          </span>
        </span>
        </label>
      </div>

      <div class="col-lg-6">
        <input
          formControlName="accountType"
          name="accountType"
          type="radio"
          class="btn-check"
          id="kt_create_account_form_account_type_corporate"
          value="advertiser"
        />
        <label
          class="
          btn btn-outline btn-outline-dashed btn-outline-default
          p-7
          d-flex
          align-items-center
        "
          for="kt_create_account_form_account_type_corporate"
        >
        <span
          [inlineSVG]="'./assets/media/icons/duotune/finance/fin006.svg'"
          class="svg-icon svg-icon-3x me-5"
        ></span>

          <span class="d-block fw-bold text-start">
          <span class="text-dark fw-bolder d-block fs-4 mb-2"
          >{{ "WIZARD.ACCOUNT_TYPE_ADVERTISER" | translate }}</span
          >
          <span class="text-gray-400 fw-bold fs-6">
            {{ "WIZARD.ACCOUNT_TYPE_ADVERTISER_DESC" | translate }}
          </span>
        </span>
        </label>
      </div>
    </div>
  </div>
  <div
    *ngIf="areOrganizationsAvailable$ | async"
    class="mt-4"
  >
    <div class="row align-items-center">
      <div class="col-lg-6">
        <select
          formControlName="organizationId"
          class="form-select form-select-lg form-select-solid me-5"
          appValidationClass
        >
          <option value="">{{ 'WIZARD.ORGANIZATION.WITHOUT_ORGANIZATION' | translate }}</option>
          <option
            *ngFor="let org of organizationsList$ | async"
            [value]="org.id"
          >
            {{org.name}}
          </option>
        </select>
      </div>
      <div class="col-lg-6">
        <span
          class="ms-3 svg-icon svg-icon-2x svg-icon-primary ms-md-1 cursor-pointer"
          [ngbTooltip]="tooltipOrgTemplate"
          tooltipClass="campaign-wizard-targeting-tooltip-box"
          [inlineSVG]="ICON_QUESTION_MARK"
        ></span>
        <ng-template #tooltipOrgTemplate>
          <p>{{'WIZARD.ORGANIZATION.TOOLTIP_1' | translate}}</p>
          <p>{{'WIZARD.ORGANIZATION.TOOLTIP_2' | translate}}</p>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="separator border-gray-200 mt-6"></div>
  <div class="d-flex justify-content-end pt-6">
    <button
      type="button"
      class="btn btn-lg btn-primary"
      (click)="nextStep.emit()"
    >
      <span class="indicator-label">
          {{'WIZARD.CONTINUE' | translate}}
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr064.svg'"
          class="svg-icon svg-icon-3 ms-2 me-0"
        ></span>
      </span>
    </button>
  </div>
</form>
